import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addTopic,
  getAddTopicError,
  getAddTopicStatus,
  setAddTopicIdleStatus,
} from "../../../redux/slice/topicSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";

const AddTopicForm = () => {
  const dispatch = useDispatch();
  const [topicName, setTopicName] = useState("");
  const [topicNameError, setTopicNameError] = useState("");

  const status = useSelector(getAddTopicStatus);
  const error = useSelector(getAddTopicError);

  const handleAddTopic = (e) => {
    e.preventDefault();
    if (!topicName) {
      setTopicNameError("Topic name is required");
    } else {
      dispatch(addTopic({ topicName }));
      setTopicName("");
    }
  };

  return (
    <section className="flex flex-col gap-4 border border-adminRightTextPrimary/40 rounded-[4px] pb-6">
      {status === "loading" ? <Loading /> : null}
      {status === "success" ? (
        <AlertBox
          type="success"
          message="Topic added successfully"
          toDispatch={setAddTopicIdleStatus}
        />
      ) : null}
      {status === "failed" ? (
        <AlertBox
          type="failed"
          message={error}
          toDispatch={setAddTopicIdleStatus}
        />
      ) : null}

      <h2 className="text-center text-adminRightTextPrimary w-full rounded-sm font-semibold py-2">
        Add a new topic
      </h2>
      <form onSubmit={handleAddTopic} className="flex flex-col gap-2">
        <div className="flex sm:flex-row flex-col gap-6 items-center md:px-10 px-2">
          <div className="flex sm:flex-row flex-col gap-2 items-center w-full">
            <label
              htmlFor="topicName"
              className="font-semibold tracking-wide text-textPrimary w-[120px] flex-none"
            >
              Topic Name:
            </label>
            <input
              type="text"
              id="topicName"
              name="topicName"
              value={topicName}
              onChange={(e) => {
                setTopicName(e.target.value);
                setTopicNameError("");
              }}
              className="admin-input-box text-textSecondary w-full"
              placeholder="Add topic"
              autoFocus
            />
          </div>
          <div>
            <button
              type="submit"
              className="border border-blue-600 text-blue-600 font-semibold h-[32px] px-4 rounded-[4px] text-sm"
            >
              Add
            </button>
          </div>
        </div>
        <span className="self-center text-[12px] italic text-red-500">
          {topicNameError}
        </span>
      </form>
    </section>
  );
};

export default AddTopicForm;
